<template>
  <div class="rb-ob-form rb-match-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.matchGapTitle') }}</h1>
    </header>

    <div class="rb-ob-status-panel">
      <p class="rb-match-outcome-body">{{ $t('intake.matchGapBody') }}</p>
    </div>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" @click="requestFollowup">
        {{ $t('intake.matchGapRequestAction') }}
      </button>
      <button class="rb-ob-submit rb-ob-submit-secondary" type="button" @click="goBack">
        {{ $route.params.lang === 'en' ? 'Edit times and preferences' : 'اصلاح زمان و ترجیحات' }}
      </button>
      <p class="rb-ob-status" role="status" aria-live="polite">{{ formStatus }}</p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {saveIntake} from '@/intake/intakeState'

export default {
  name: 'MatchGapStep',
  data() {
    return {
      formStatus: '',
    }
  },
  methods: {
    requestFollowup() {
      saveIntake({followupRequested: true})
      this.formStatus = this.$t('intake.matchGapRequestDone')
      this.$router.push({
        name: 'dashboard',
        params: {lang: this.$route.params.lang || 'fa'},
      })
    },
    goBack() {
      // Supply gap is not fixed by re-running the same search.
      this.$router.push({
        name: 'intakeScreening',
        params: {lang: this.$route.params.lang || 'fa'},
        query: {revise_preferences: '1'},
      })
    },
  },
}
</script>
